import { create } from "zustand";
import { VetisState } from "./types";
import { useApiariesStore } from "entities/apiaries";
import { $api } from "shared/api";
import { useUserStore } from "entities/user";
import { toast } from "react-toastify";
import { useMercuryStore } from "entities/mercury";

export const useVetisStore = create<VetisState>((set, get) => ({
  hasVetisBusiness: false,
  isIAmVetisUser: false,
  vetisBusiness: null,
  vetisUser: null,
  isBusinessDrawerOpen: false,
  isUserDrawerOpen: false,
  openUserAfterAddBusiness: false,
  checkVetisAccess: async () => {
    const currentApiary = useApiariesStore.getState().currentApiary();
    if (!currentApiary) return;

    const ownerId = currentApiary.owner.id;
    const businessRes = await $api.get(`/fgis-soap-native/api/Client/GetBusinessByExternalId/${ownerId}`).catch(console.warn)
    if (!businessRes) {
      set({
        hasVetisBusiness: false,
        isIAmVetisUser: false,
      })

      return;
    }
    set({
      hasVetisBusiness: true,
      vetisBusiness: businessRes.data
    })

    const myId = useUserStore.getState().userInfo?.id;
    const userRes = await $api.get(`/fgis-soap-native/api/Client/GetUserByExternalId/${myId}`).catch(console.warn)
    if (!userRes) {
      set({
        isIAmVetisUser: false
      })

      return;
    }
    const {
      getMercuryDictionaries,
      getJournalEntries,
      getTransactionEntries
    } = useMercuryStore.getState();

    await getMercuryDictionaries();
    getJournalEntries();
    getTransactionEntries();

    set({
      isIAmVetisUser: true,
      vetisUser: userRes.data
    })
  },
  addBusiness: async (params) => {
    const {checkVetisAccess, openUserAfterAddBusiness} = get();

    const currentApiary = useApiariesStore.getState().currentApiary();
    if (!currentApiary) return;
    const externalId = currentApiary.owner.id;

    if (!params.externalId) {
      params.externalId = externalId
    }

    const path = `/fgis-soap-native/api/Client/AddBusiness`
    const res = await $api.post(path, params).catch(err => {
      const errText = err?.response?.data?.message;
      if (errText) {
        toast.error(errText)
      }
    })

    if (!res) return;
    console.log(res);
    toast.success('Данные для входа приняты. Если на странице отсутствуют изменения - перезагрузите её');
    if (openUserAfterAddBusiness) {
      set({
        isUserDrawerOpen: true,
        openUserAfterAddBusiness: false,
      })
    }
    checkVetisAccess();
  },

  addUser: async ({login}) => {
    const { checkVetisAccess, vetisBusiness } = get();
    const businessId = vetisBusiness?.issuerId;
    const externalId = useUserStore.getState().userInfo?.id;
    if (!businessId||!externalId) return;

    const path = '/fgis-soap-native/api/Client/AddUser';
    const params = {
      businessId,
      externalId,
      login
    }

    const res = await $api.post(path, params).catch(err => {
      const errText = err?.response?.data?.message;
      if (errText) {
        toast.error(errText)
      }
    })

    if (!res) return;
    toast.success('Данные для входа приняты. Если на странице отсутствуют изменения - перезагрузите её');
    checkVetisAccess();
  },
  
  removeBusiness: async () => {
    const { checkVetisAccess, vetisUser } = get();
    const { removeDefaultBusinessEntitity } = useMercuryStore.getState();

    if (!vetisUser) return;

    const path = '/fgis-soap-native/api/Client/RemoveBusiness';
    const params = {
      externalId: vetisUser.business.externalId,
      issuerId: vetisUser.businessId
    }

    await $api.delete(path, {
      params
    }).catch(console.warn);

    removeDefaultBusinessEntitity();
    checkVetisAccess();
  },
  removeUser: async () => {
    const { checkVetisAccess, vetisUser } = get();
    const { removeDefaultBusinessEntitity } = useMercuryStore.getState();

    if (!vetisUser) return;

    const path = '/fgis-soap-native/api/Client/RemoveUser';
    const params = {
      externalId: vetisUser.externalId,
    }

    await $api.delete(path, {
      params
    }).catch(console.warn);

    removeDefaultBusinessEntitity();
    checkVetisAccess();
  },
  setBusinessDrawerOpen: (val) => {
    set({
      isBusinessDrawerOpen: val
    })
  },
  setUserDrawerOpen: (val) => {
    set({
      isUserDrawerOpen: val
    })
  },
  setOpenUserAfterAddBusiness: (val) => {
    set({
      openUserAfterAddBusiness: val
    })
  },
}))